export interface NxScopeFileInfo {
    key: string;
    fileName: string;
    lastModified: Date;
    size: number;
}

export interface NxScopeLogResponse {
    files: NxScopeFileInfo[];
}

export class NxScopeLog {
    key: string;
    fileName: string;
    lastModified: Date;
    size: number;
    deviceName: string;
    fileType: 'statistics' | 'logs';
    timestamp: string;

    constructor(data: NxScopeFileInfo) {
        this.key = data.key;
        this.fileName = data.fileName;
        this.lastModified = new Date(data.lastModified);
        this.size = data.size;
        
        // Parse device name and file type from key
        // Key format: device-logs/{organizationId}/{deviceName}/statistics_{timestamp}.json
        // or: device-logs/{organizationId}/{deviceName}/raw_logs_{timestamp}.log
        const keyParts = this.key.split('/');
        this.deviceName = keyParts[2] || 'Unknown';
        
        // Determine file type and extract timestamp
        if (this.fileName.startsWith('statistics_')) {
            this.fileType = 'statistics';
            this.timestamp = this.fileName.replace('statistics_', '').replace('.json', '');
        } else if (this.fileName.startsWith('raw_logs_')) {
            this.fileType = 'logs';
            this.timestamp = this.fileName.replace('raw_logs_', '').replace('.log', '');
        } else {
            this.fileType = 'logs'; // default
            this.timestamp = '';
        }
    }

    // Format file size in human readable format
    getFormattedSize(): string {
        const bytes = this.size;
        if (bytes === 0) return '0 Bytes';
        
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }

    // Get formatted timestamp
    getFormattedTimestamp(): string {
        if (!this.timestamp) return 'Unknown';
        
        // If timestamp is in format YYYYMMDD_HHMMSS
        if (this.timestamp.length === 15 && this.timestamp.includes('_')) {
            const [datePart, timePart] = this.timestamp.split('_');
            const year = datePart.substring(0, 4);
            const month = datePart.substring(4, 6);
            const day = datePart.substring(6, 8);
            const hour = timePart.substring(0, 2);
            const minute = timePart.substring(2, 4);
            const second = timePart.substring(4, 6);
            
            return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
        }
        
        return this.timestamp;
    }
}